import {
	ContractType,
	PerpMarketAccount,
	PerpMarketConfig,
	SpotMarketConfig,
} from '@drift-labs/sdk';
import { ENUM_UTILS } from '@drift/common';
import dayjs from 'dayjs';
import { MarketCategory } from 'src/constants/markets';

export function getMarketSelectorPricePercentChange(
	markPrice: number,
	price24hAgo: number
) {
	const pricePercentChange =
		price24hAgo && markPrice
			? 100 * ((markPrice - price24hAgo) / price24hAgo)
			: 0;

	return pricePercentChange;
}

const NEW_AND_TRENDING_WEEKS = 3;

export function perpMarketCategoryFilter(
	market: PerpMarketConfig,
	marketCategory: MarketCategory,
	isHot: boolean,
	perpMarketAccount: PerpMarketAccount | undefined
) {
	const isPredictionMarket = ENUM_UTILS.match(
		perpMarketAccount?.contractType,
		ContractType.PREDICTION
	);

	if (isPredictionMarket) {
		return false;
	}

	if (marketCategory === 'all') {
		return true;
	}

	if (marketCategory === 'newAndTrending') {
		return (
			dayjs(market.launchTs)
				.add(NEW_AND_TRENDING_WEEKS, 'week')
				.isAfter(dayjs()) || isHot
		);
	}

	return false;
}

export function spotMarketCategoryFilter(
	market: SpotMarketConfig,
	marketCategory: MarketCategory
) {
	if (marketCategory === 'all') {
		return true;
	}

	if (marketCategory === 'newAndTrending') {
		return dayjs(market.launchTs)
			.add(NEW_AND_TRENDING_WEEKS, 'week')
			.isAfter(dayjs());
	}

	return false;
}
